// API numbers may arrive as strings; missing values must never become a rating.
export function getProductRating(avgRank: unknown, total: unknown) {
  const toNumber = (value: unknown) => (
    typeof value === 'number' || (typeof value === 'string' && value.trim())
      ? Number(value)
      : NaN
  )
  const ratingValue = toNumber(avgRank)
  const reviewCount = toNumber(total)

  return Number.isFinite(ratingValue) && ratingValue >= 1 && ratingValue <= 5
    && Number.isSafeInteger(reviewCount) && reviewCount > 0
    ? { ratingValue, reviewCount }
    : undefined
}
